'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.playVideo = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var playVideo = exports.playVideo = function playVideo(videoID, videoContainer) {
	'use strict';

	$(videoContainer).html('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + videoID + '?autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen wmode="Opaque"></iframe>');
	$(videoContainer).css('z-index', '2');
};